module.exports = __webpack_public_path__ + "img/CHEVRON_RIGHT.c85989e6.svg";